<template>
  <div id="Topic">
    <b-container fluid>
      <b-row
        class="background background_filter page_header_row"
        :style="{ 'background-image': `url(${topic.topic_thumbURL})` }"
      >
        <b-col cols="12" class="u-non-blurred">
          <div class="page_header_inner">
            <div class="header_back_button" @click="back">
              <b-icon-chevron-left aria-hidden="true" /> Back
            </div>
            <div class="header_breadcrumb" role="heading" aria-level="1">
              <span class="crumb_item">AP World History</span>
              <span class="crumb_sep" aria-hidden="true">→</span>
              <span class="crumb_item"
                >{{ timePeriodHeaders.header }} ({{ timePeriodHeaders.subheader }})</span
              >
              <span v-if="topic.unit" class="crumb_sep" aria-hidden="true">→</span>
              <span v-if="topic.unit" class="crumb_item">{{ topic.unit }}</span>
              <span v-if="topic.title" class="crumb_sep" aria-hidden="true">→</span>
              <span v-if="topic.title" class="crumb_item crumb_current">{{ topic.title }}</span>
            </div>
          </div>
          <p class="topic_header">Topic: {{ topic.title }} </p>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="mb-5 ml-3 topic_main_container">
      <div class="sidebar topic-progress-nav">
        <div class="topic_nav_buttons d-flex flex-wrap align-items-center gap-2">
          <div v-for="(button, index) in topicButtons" :key="index">
            <div
              class="category_button"
              :class="{ active: currentTopicCategory === button }"
              @click="loadCategory(button)"
            >
              {{ button }}
            </div>
          </div>
        </div>
        <div v-if="showStickySearch" class="topic_search_slot">
          <search-bar placeholder="Search this topic or site..." />
        </div>
        <div v-if="showStickySearch" class="d-flex justify-content-end top_button_slot">
          <b-button class="top-pill" @click="top()" aria-label="Scroll to top">
            <b-icon-caret-up-fill class="top-pill-caret" aria-hidden="true" /> Top
          </b-button>
        </div>
      </div>
      <b-row class="pt-5 topic_layout_row">
        <b-col cols="12" class="pa-0 topic-content-column">
          <div :style="{ display: display_loader }">
            <b-row>
              <b-col cols="7">
                <div class="large_image loading_topic"></div>
                <div class="small_content100p loading_topic"></div>
                <div class="small_content80p loading_topic"></div>
                <div class="small_content95p loading_topic"></div>
                <div class="small_content90p loading_topic"></div>
                <div class="small_content80p loading_topic"></div>
                <div class="small_content100p loading_topic"></div>
                <div class="small_content95p loading_topic"></div>
              </b-col>
              <b-col class="vidoes">
                <div
                  v-for="i in 5"
                  :key="i.id"
                  class="video loading_topic"
                ></div>
              </b-col>
            </b-row>
          </div>
          <div :style="{ display: display_comps }">
            <intro
              id="Introduction"
              class="findByScroll"
              :topic="topic"
            ></intro>
            <trends id="Trends" class="findByScroll"></trends>
            <developments id="Events" class="findByScroll"></developments>
            <people id="People" class="findByScroll"></people>
            <primarysources id="Sources" class="findByScroll"></primarysources>
            <terms id="Terms" class="findByScroll"></terms>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import store from "@/store";
import { pushRoute } from "@/router/navigation";
import { trackEvent } from "@/services/analyticsService";
import storeTopic from "@/store/topic.js";
import intro from "@/components/Intro.vue";
import trends from "@/components/Trends.vue";
import developments from "@/components/Developments2.vue";
import people from "@/components/People.vue";
import primarysources from "@/components/PrimarySources.vue";
import terms from "@/components/Terms.vue";
import SearchBar from "@/components/SearchBar.vue";
import { db } from "@/main";
import VueScrollTo from "vue-scrollto";

export default {
  name: "Topics",
  components: {
    intro,
    trends,
    developments,
    people,
    primarysources,
    terms,
    SearchBar
  },
  data() {
    return {
      topicButtons: [
        "Introduction",
        "Trends",
        "Events",
        "People",
        "Sources",
        "Terms"
      ],
      router_comp: "",
      display_loader: "block",
      display_comps: "none",
      viewedSections: {},
      topicCompletedTracked: false,
      showStickySearch: false
    };
  },

  watch: {
    loaded(newValue) {
      if (newValue === 6) {
        this.viewedSections = {};
        this.topicCompletedTracked = false;
        this.trackTopicSectionView(this.router_comp || "Introduction");
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
          this.display_loader = "none";
        }, 500);
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
          this.display_comps = "block";
        }, 900);
        setTimeout(() => {
          store.dispatch("setTopicCategory", this.router_comp);
          if (this.router_comp == "Introduction") {
            window.scrollTo({ top: 0, behavior: "smooth" });
          } else {
            const sectionEl = document.getElementById(this.router_comp);
            if (sectionEl) {
              sectionEl.scrollIntoView({ behavior: "smooth", block: "start" });
            }
          }
        }, 1100);
        // If a caller requested scrolling to a specific item (via query param
        // `scrollTo`), perform that scroll after components have rendered.
        setTimeout(() => {
          const target = this.$route.query?.scrollTo;
          if (target) {
            const el = document.getElementById(target);
            if (el) {
              el.scrollIntoView({ behavior: "smooth", block: "start" });
              // remove the query so subsequent navigations don't re-trigger
              this.$router.replace({
                name: "Topic",
                params: this.$route.params,
                query: {}
              });
            } else {
              setTimeout(() => {
                const el2 = document.getElementById(target);
                if (el2) {
                  el2.scrollIntoView({ behavior: "smooth", block: "start" });
                } else if (this.router_comp && this.router_comp !== "Introduction") {
                  const sectionEl = document.getElementById(this.router_comp);
                  if (sectionEl) {
                    sectionEl.scrollIntoView({ behavior: "smooth", block: "start" });
                  }
                }
                this.$router.replace({
                  name: "Topic",
                  params: this.$route.params,
                  query: {}
                });
              }, 250);
            }
          }
        }, 1300);
        setTimeout(() => {
          window.addEventListener("scroll", this.updateCurrentSection);
          window.addEventListener("scroll", this.handleTopicCompletionScroll);
          window.addEventListener("scroll", this.updateStickySearchVisibility);
          this.updateStickySearchVisibility();
        }, 2000);
      }
    },
    // If a caller sets `?scrollTo=...` while we're already on the Topic page
    // and the components are visible, scroll immediately.
    "$route.query.scrollTo": function(target) {
      if (!target) return;
      // Only attempt immediate scroll when components are displayed
      if (this.display_comps === "block") {
        this.$nextTick(() => {
          const el = document.getElementById(target);
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
            // clear query so repeated navigations don't re-trigger
            this.$router.replace({
              name: "Topic",
              params: this.$route.params,
              query: {}
            });
            return;
          }
          // element might render slightly later; try once more after a short delay
          setTimeout(() => {
            const el2 = document.getElementById(target);
            if (el2) {
              el2.scrollIntoView({ behavior: "smooth", block: "start" });
              this.$router.replace({
                name: "Topic",
                params: this.$route.params,
                query: {}
              });
            }
          }, 350);
        });
      }
    }
  },
  computed: {
    timePeriodHeaders() {
      return store.state.timePeriodHeaders[store.state.currentTimePeriod];
    },
    currentTopicCategory() {
      return store.state.currentTopicCategory;
    },
    topic() {
      return storeTopic.state.topic;
    },
    loaded() {
      console.log("storeTopic.state.loaded", storeTopic.state.loaded);
      return storeTopic.state.loaded;
    }
  },
  methods: {
    trackTopicSectionView(section) {
      if (!section || this.viewedSections[section]) {
        return;
      }

      this.viewedSections[section] = true;
      trackEvent("topic_section_viewed", {
        topic_id: this.topic.id || this.$route.params.topic,
        topic_title: this.topic.title || null,
        section
      });
    },
    handleTopicCompletionScroll() {
      if (this.topicCompletedTracked) {
        return;
      }

      const doc = document.documentElement;
      const scrollTop = window.pageYOffset || doc.scrollTop || 0;
      const scrollable = (doc.scrollHeight || 0) - window.innerHeight;

      if (scrollable <= 0) {
        return;
      }

      const scrollRatio = scrollTop / scrollable;
      if (scrollRatio >= 0.9) {
        this.topicCompletedTracked = true;
        trackEvent("topic_completed", {
          topic_id: this.topic.id || this.$route.params.topic,
          topic_title: this.topic.title || null,
          completion_threshold: 0.9
        });
      }
    },
    top() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    updateStickySearchVisibility() {
      // Only show the sidebar search once the site navbar has scrolled out of view
      const navbar = document.querySelector(".navbar_styling");
      const navbarHeight = navbar ? navbar.getBoundingClientRect().bottom : 0;
      this.showStickySearch = navbarHeight <= 0;
    },
    scrollToSection(index) {
      VueScrollTo.scrollTo(`#${this.topicButtons[index]}`, 1000);
      setTimeout(() => {
        this.updateCurrentSection();
      }, 0);
    },
    updateCurrentSection() {
      for (let index = 0; index < this.topicButtons.length; index++) {
        const section = document.getElementById(this.topicButtons[index]);

        const rect = section.getBoundingClientRect();
        const isVisible = rect.top >= 0 && rect.top <= window.innerHeight / 2;

        if (isVisible) {
          this.trackTopicSectionView(this.topicButtons[index]);

          store.dispatch("setTopicCategory", this.topicButtons[index]);
          this.$router.replace({
            name: "Topic",
            params: { category: this.topicButtons[index] }
          });
          break;
        }
      }
    },
    async topicFinder() {
      store.dispatch("setTimePeriod", this.$route.params.period);
      var newTopic;
      await db
        .collection("topics")
        .doc(this.$route.params.topic)
        .get()
        .then(
          function(querySnapshot) {
            var entry = querySnapshot.data();
            entry.id = querySnapshot.id;
            newTopic = entry;
            storeTopic.dispatch("setTopicContent", newTopic);
          }.bind(this)
        );
    },
    back() {
      trackEvent("topic_back_button_clicked", {
        topic_id: this.topic.id || this.$route.params.topic,
        topic_title: this.topic.title || null
      });
      store.dispatch("setTopicCategory", "");
      pushRoute(
        "Period",
        { period: this.$route.params.period },
        { unit: this.topic.unit || "" }
      );
    },
    loadCategory(category) {
      document
        .getElementById(category)
        .scrollIntoView({ top: -100, behavior: "smooth" });
      store.dispatch("setTopicCategory", category);
      this.$router.replace({ name: "Topic", params: { category: category } });
    }
  },
  beforeMount() {
    console.log("beforeMount");
    const cat = this.$route.params.category;
    if (cat) {
      const match = this.topicButtons.find(
        b => b.toLowerCase() === cat.toLowerCase()
      );
      this.router_comp = match || cat;
    } else {
      this.router_comp = "Introduction";
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (Object.keys(storeTopic.state.topic).length === 0) {
      this.topicFinder();
      storeTopic.dispatch("loader_add1");
    } else if (
      Object.keys(storeTopic.state.topic).length > 0 &&
      storeTopic.state.loaded >= 6
    ) {
      storeTopic.dispatch("restLoader");
      storeTopic.dispatch("loader_add1");
    } else {
      storeTopic.dispatch("loader_add1");
    }
    store.dispatch("setTopicCategory", this.$route.params.category);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.updateCurrentSection);
    window.removeEventListener("scroll", this.handleTopicCompletionScroll);
    window.removeEventListener("scroll", this.updateStickySearchVisibility);
  }
};
</script>
<style lang="sass" scoped>
@import "@/assets/css/topicContent.sass"
@import "@/assets/css/loading.sass"

.topic-content-column
  min-width: 0

.topic_main_container,
.topic_layout_row,
.topic-content-column
  overflow: visible

.topic_main_container
  --topic-nav-sticky-top: 64px
  --topic-nav-sticky-top-mobile: 56px

.topic_layout_row
  align-items: flex-start

.sidebar
  position: sticky
  top: 0
  z-index: 50
  align-self: flex-start
  width: 100%
  height: fit-content
  display: flex
  flex-direction: row
  flex-wrap: wrap
  align-items: center
  gap: 10px
  padding: 10px 14px
  background: #ffffff
  border-bottom: 1px solid rgba(24, 25, 31, 0.08)
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04)

.topic_nav_buttons
  display: flex
  flex-wrap: wrap
  align-items: center
  gap: 8px

.category_button
  margin: 0
  white-space: nowrap

.topic_search_slot
  flex: 0 1 270px
  min-width: 220px
  margin-left: auto

  :deep(.search-bar-wrapper)
    width: 100%
    max-width: 270px
    border: 1.5px solid #33401a
    border-radius: 10px

  :deep(.search-bar)
    width: 100%
    height: 40px
    border-radius: 10px
    border: none

  :deep(.search-input)
    font-size: 14px

  :deep(.search-button)
    padding: 0 12px
    font-size: 14px

  :deep(.typeahead)
    width: 100%
    min-width: 270px
    max-height: 300px
    z-index: 10000

.top_button_slot
  display: flex
  align-items: center

.top-pill
  display: inline-flex !important
  align-items: center !important
  gap: 8px !important
  font-family: "Montserrat", sans-serif !important
  font-weight: 700 !important
  font-size: 15px !important
  line-height: 1 !important
  color: #33401a !important
  background: none !important
  border: 4px solid #c9e265 !important
  border-radius: 12px !important
  padding: 10px 15px !important
  margin: 0 !important
  box-shadow: none !important
  transition: all 0.2s ease !important
  cursor: pointer !important

  &:hover
    background: rgba(201, 226, 101, 0.15) !important
    transform: translateY(-2px) !important

  &:active
    transform: translateY(0) !important
    background: rgba(201, 226, 101, 0.25) !important

  .top-pill-caret
    color: #33401a !important
    // svg icon size is 1em, so bump its own font-size to enlarge it
    font-size: 1.2em !important

@media (max-width: 991px)
  .sidebar
    gap: 8px
    padding: 8px

  .topic_search_slot
    flex: 1 1 100%
    order: 3
    margin-left: 0
    margin-top: 4px

    :deep(.search-bar-wrapper)
      max-width: 100%
      width: 100%

  .top_button_slot
    margin-left: auto

@media (max-width: 768px)
  .sidebar
    top: 0px

  .top-pill
    font-size: 14px !important
    padding: 8px 14px !important

.page_header_row
  min-height: 132px
  padding: 16px 22px

.page_header_inner
  min-height: 100px
  width: 100%
  display: flex
  align-items: center
  gap: 14px

.header_back_button
  display: inline-flex
  align-items: center
  gap: 6px
  padding: 6px 14px
  font-family: "Montserrat", sans-serif
  font-weight: 700
  font-size: 14px
  color: #fff
  background: rgba(91, 33, 182, 0.4)
  border: 1px solid rgba(91, 33, 182, 1)
  border-radius: 10px
  backdrop-filter: blur(6px)
  text-decoration: none
  cursor: pointer
  transition: all 0.25s ease

.header_back_button:hover
  background: #5B21B6
  transform: translateY(-1px)

.header_back_button:active
  transform: translateY(0)

.header_breadcrumb
  display: flex
  align-items: center
  flex-wrap: wrap
  gap: 6px
  min-width: 0
  color: #ffffff
  font-family: "Montserrat", sans-serif
  letter-spacing: -0.4px
  font-size: 22px
  line-height: 1.2
  font-weight: 500

.topic_header
  margin: 0
  color: white !important
  font-family: "Montserrat", sans-serif
  letter-spacing: -0.6px
  line-height: 1.1
  font-weight: 500
  font-size: clamp(34px, 2.8vw, 48px)
  text-align: center

.crumb_item
  max-width: 100%
  word-break: break-word

.crumb_current
  font-weight: 700

.crumb_sep
  color: rgba(255, 255, 255, 0.82)
  font-size: 20px
  line-height: 1

@media (max-width: 920px)
  .page_header_row
    min-height: 124px
    padding: 14px 14px

  .page_header_inner
    gap: 10px

  .header_breadcrumb
    font-size: 18px

@media (max-width: 576px)
  .page_header_inner
    align-items: flex-start
    flex-direction: column
    justify-content: center

  .header_back_button
    padding: 5px 10px
    font-size: 13px

  .header_breadcrumb
    font-size: 16px
    gap: 4px
</style>
